import { useGenerateSignedUrlQuery } from '@/app/services/generatedReportApi';
import DownloadIcon from '@mui/icons-material/Download';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

function FilePathLink(params: { projectCode: string }) {
  const { t } = useTranslation(['projects']);

  const { projectCode } = params;
  const { data } = useGenerateSignedUrlQuery({ projectCode });

  return (
    <div
      style={{
        width: '135px',
        textAlign: 'start',
      }}
    >
      <a
        href={data?.filePath}
        style={{
          textTransform: 'none',
          textDecoration: 'none',
          color: 'inherit',
          display: 'flex',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <DownloadIcon />
          {t('download.report')}
        </Box>
      </a>
    </div>
  );
}

export default FilePathLink;
